import React, {  useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import ProjectGridTable from "../../../layouts/ProjectGridTable";

function ProgressBar({ currentStep }) {

  const steps = [
    "Configure project",
    "Configure deployment",
    "Configure device",
    "On lease",
    "Lease complete",
  ];

  return (
    <Box sx={{ width: "100%", p: 3, overflow:"auto"}}>
      <Stepper activeStep={currentStep} alternativeLabel>
        {steps.map((label) => (
          <Step
            sx={{
              "& .MuiStepLabel-root .Mui-completed": {
                color: "#00FF00",
              },
              "& .MuiStepLabel-label.Mui-completed.MuiStepLabel-alternativeLabel":
                {
                  color: "white",
                },
            }}
            key={label}
          >
            <StepLabel
              sx={{
                "& .MuiStepLabel-label.MuiStepLabel-alternativeLabel": {
                  color: "GrayText", // Default step color
                },
                "& .MuiStepLabel-label.Mui-completed.MuiStepLabel-alternativeLabel":
                  {
                    color: "white", // Completed step color
                  },
              }}
            >
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}

const Projects = ({setActiveTab, activeTab}) => {
  const [currentStep, setCurrentStep] = useState(0);

  return (
    <>
      {/* Stepper */}
      {currentStep ? <ProgressBar currentStep={currentStep} /> : null}
      {/* CRUD Data Grid */}
      <ProjectGridTable setCurrentStep={setCurrentStep} setActiveTab={setActiveTab}  />
    </>
  );
};

export default Projects;
